import { Link } from "react-router-dom";

export function SignUpButton(props: { isMobile: boolean }) {
    return <Link to="/pricing" className={props.isMobile ? 'btn btn--sign-up btn--mobile' : 'btn btn--sign-up'}>
        <span>START FREE TRIAL</span>
    </Link>
}
